/*
{
  url: string -- 이동하려는 주소('/project/1') 또는 라우터 이름({name:'', params:{id:1}})
}

2024-04-22
이 파일은 /src/layouts/sidemenu/MainLayout.vue 파일에 불려집니다.
기존에는 이 파일에 정의되지 않은 프로젝트는, 전체 대시보드의 사이드 메뉴에 표시되지 않았습니다.
그리고 사이드메뉴에 표시되는 프로젝트의 이름이 이 파일에 정의된 name 값으로 표시되었었기 때문에
프로젝트 이름을 변경하려면 이 파일을 수정해야 했습니다.

MainLayout.vue 파일을 변경하면서, 이 파일에서는 프로젝트의 순서와 url, icon 정보만이 의미를 갖게 되었습니다.
name, activeCode, project_type 등의 값은 의미를 갖지 않습니다.
*/
export default [
  {
    url: {name: 'project-home', params:{proj_id: 1}},
    name: '총괄관리',
    icon: 'AlertTriangleIcon',
    activeCode: '',
    project_type: '총괄관리',
  },
  {
    url: {name: 'project-home', params:{proj_id: 2}},
    name: 'Standard Ver',
    icon: 'AlertTriangleIcon',
    activeCode: '',
    project_type: 'Standard Ver',
  },
  {
    url: {name: 'project-home', params:{proj_id: 3}},
    name: 'Data Base Team',
    icon: 'FileTextIcon',
    activeCode: '',
    project_type: 'Data Base Team',
  },
  {
    url: {name: 'project-home', params:{proj_id: 4}},
    name: '파트너입찰(1억이하)',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '파트너입찰(1억이하)',
  },
  {
    url: {name: 'project-home', params:{proj_id: 5}},
    name: '파트너입찰(1억이상)',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '파트너입찰(1억이상)',
  },
  {
    url: {name: 'project-home', params:{proj_id: 6}},
    name: '삼성 에스원',
    icon: 'ShieldIcon',
    activeCode: '',
    project_type: '삼성 에스원',
  },
]
